import React from 'react'
export const VenueContext = React.createContext(null);
export const AuthContext = React.createContext(null);
export const PaymentRequestContext = React.createContext(null);
export const ThemeContext = React.createContext(null);